import { LogLevel, getLogger } from '@ori/checkout-utils';
import { type ReactNode, Component } from 'react';

import { APP_NAME } from '../constants';

interface ErrorBoundaryProps {
  children: JSX.Element;
}

interface ErrorBoundaryState {
  error?: Error;
}

const logError = getLogger(APP_NAME, LogLevel.Error);

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override readonly state: ErrorBoundaryState = {};

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  override render(): ReactNode {
    const { error }: ErrorBoundaryState = this.state;

    if (error) {
      logError('ErrorBoundary: ', error);

      return null;
    }

    const { children }: ErrorBoundaryProps = this.props;

    return children;
  }
}
